import PrincipalBanner from "../../contents/PrincipalBanner";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import Collapse from "../../components/Collapse";

const Page = () => {
  return (
    <main className="mx-auto max-w-7xl">
      <PrincipalBanner
        bgColor="grape-light"
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[490px] p-0"))}
      >
        <img
          className="absolute min-w-full min-h-full object-cover"
          src="https://static.igem.wiki/teams/5058/topocontribuition.png"
          alt="bannner engineering"
        />
        <h1 className="invisible">Contribuition</h1>
      </PrincipalBanner>

      <section className=" font-nunito">
        <h2 className="embadge">OVERVIEW</h2>
        <p className="px-6 pb-6 font-manjari text-3xl leading-normal">
          Our team is contributing to the iGEM community by registering new
          basic parts and a DEGRON system (protein depletion system).
          Additionally, we are providing protocols and templates for the
          educational activities we have conducted, making them accessible for
          broader use.
        </p>
      </section>

      <section className="">
        <h2 className={"title-engrand"}>basic parts</h2>
        <p>
          In terms of basic parts, we added two new S. cerevisiae promoters in
          the iGEM registry: the heat shock promoter (HSE), which is activated
          in response to heat stress, and ADH2, which is repressed under high
          glucose conditions but strongly induced during glucose depletion. We
          measured the activity of ADH2 having as reporter LacZ expression
          (B-galactosidase activity assay). Additionally, we introduced an
          alternative method for protein depletion using a genetic circuit, the
          DEGRON system. This synthetic system, a combination of the Arabidopsis
          thaliana and the host ubiquitin pathway, enables the degradation of a
          target protein upon the addition of auxin, a plant hormone. For this
          purpose, the target sequence is labeled with an mAID sequence (minimal
          Auxin-Inducible Degron). The target then can interact with the A.
          thaliana Tir1 protein, upon adding auxin to the medium. This approach
          can assist future teams in constructing genetic circuits that maintain
          the native protein active which can be controlled with auxin.
        </p>
      </section>
      <section className="py-0 pb-4">
        <h2 className="inverse title">protocols and templates</h2>
        <p>
          Finally, we have provided all protocols and templates for each
          educational activity performed during the iGEM competition. By doing
          so, we aim to facilitate the replication of these activities by other
          teams or educators in their local regions. As education is a
          collaborative effort to improve the world and society, sharing our
          activities and methodologies is essential, and may help further iGEM
          teams.
        </p>
      </section>
      <section className="py-0 pb-4">
        <h2 className="inverse title">links</h2>
        <p className="text-right">
          To access and learn more about this content, please see our parts page
          and our educational page.
        </p>
      </section>
      <section className="py-0 pb-4">
        <Collapse>
          <Collapse.Title>References</Collapse.Title>
          <Collapse.Content>
            <p>
              1. Beier, D. R., & Young, E. T. (1982). Regulation of ADH2
              expression in Saccharomyces cerevisiae by glucose and the ADR1
              gene product. Proceedings of the National Academy of Sciences,
              79(14), 4522-4526.
            </p>
            <p>
              2. Shuster, J. R. (1982). A high-level, glucose-repressible
              promoter from the Saccharomyces cerevisiae ADH2 gene. Gene, 20(1),
              51-58.
            </p>
            <p>
              3. Slater, M R, and E A Craig. “Transcriptional regulation of an
              hsp70 heat shock gene in the yeast Saccharomyces cerevisiae.”
              Molecular and cellular biology vol. 7,5 (1987): 1906-16.
              doi:10.1128/mcb.7.5.1906-1916.1987
            </p>
            <p>
              4. Morawska M, Ulrich HD. An expanded tool kit for the
              auxin-inducible degron system in budding yeast. Yeast. 2013
              Sep;30(9):341-51. doi: 10.1002/yea.2967. Epub 2013 Jul 23. PMID:
              23836714; PMCID: PMC4171812
            </p>
          </Collapse.Content>
        </Collapse>
      </section>
    </main>
  );
};
export default Page;
